export default function removeSpace(string) {
    let str = string.replace(/\s/g, "");
    return str;
}
